module.exports = new __parcel__URL__("og.ba3bd5db.png").toString();